export default __webpack_public_path__ + "static/Mortar_And_Pestle-801642b734a1e38413057e2bb58b92ff.png";